<template>
    <b-card body-class="flightCard" @click="() => $emit('click')">
        <p class="h4 mt-0 mb-0">
            <strong>{{ flightData.number }}</strong> |
            <small>{{ flightData.airline }}</small>
        </p>
        <b-row no-gutters>
            <b-col>
                <p class="mb-0 airportName">{{ flightData.departure.airportName }}</p>
                <p class="mb-0 flightSchedule" v-if="departureDatetime.isValid()">
                    <strong>{{ departureDatetime.format('HH:mm') }}</strong> |
                    <small>{{ departureDatetime.format('dddd, D MMM YYYY') }}</small>
                </p>
                <p class="mb-0 flightSchedule" v-else>El horario no esta disponible</p>
				<b-button variant="primary" @click="returnDateTimeFlight()">Usar datos del vuelo</b-button>
            </b-col>
            <b-col cols="1">
                <md-icon :icon="'arrow_forward'"/>
            </b-col>
            <b-col>
                <p class="mb-0 airportName">{{ flightData.arrival.airportName }}</p>
                <p class="mb-0 flightSchedule" v-if="arrivalDatetime.isValid()">
                    <strong>{{ arrivalDatetime.format('HH:mm') }}</strong> |
                    <small>{{ arrivalDatetime.format('dddd, D MMM YYYY') }}</small>
                </p>
                <p class="mb-0 flightSchedule" v-else>El horario no esta disponible</p>
            </b-col>
        </b-row>
    </b-card>

</template>

<script>
    import moment from 'moment'
    moment.locale("es")
    export default {
        name:'FlightItem',
        props: {
            flightData: {
                type: Object,
            },
			typeOfFlight:{
				type: String,
				default: "SALIDA"
			}
        },
        data(){
            return {moment}
        },
        computed: {
            departureDatetime() {
                // eslint-disable-next-line
                return moment(this.flightData.departure.scheduledTime??'--');
                //return this.$moment(this.flightData.departure.scheduledTime);
            },
            arrivalDatetime() {
                // eslint-disable-next-line
                return moment(this.flightData.arrival.scheduledTime);
            },
        },
        mounted() {},
		methods:{
			returnDateTimeFlight(){
				//es vuelo de llegada?
				if(this.typeOfFlight=="LLEGADA"){
					this.$emit('updateDateTimeFlight', this.arrivalDatetime.format('YYYY-MM-DD'), this.arrivalDatetime.format('HH:mm'))
				}//es vuelo de salida?
				else{
					this.$emit('updateDateTimeFlight', this.departureDatetime.format('YYYY-MM-DD'), this.departureDatetime.format('HH:mm'))
				}
			}
		}
    };
</script>

<style scoped>
    .flightCard {
        cursor: pointer;
        padding: 5px 10px !important;
    }
    .airportName {
        line-height: 20px;
    }
    .flightSchedule {
        font-size: 18px;
        line-height: 25px;
    }
    .icon {
        font-size: 35px;
    }
</style>
